module.exports = __webpack_public_path__ + "static/media/ckn_usuarios_rol.e6b516ee.jpg";